import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const DictionaryLinkCard = () => {
  return (
    <section className="mb-16 animate-slide-up stagger-2">
      <Link
        to="/dicionario"
        className="block p-8 rounded-2xl bg-card border border-border hover:border-primary/50 transition-all hover:shadow-lg group"
      >
        <div className="flex flex-col md:flex-row md:items-center gap-6">
          <div className="p-4 rounded-xl bg-primary/10 w-fit">
            <BookOpen className="h-10 w-10 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-2 group-hover:text-primary transition-colors">
              Dicionário Imobiliário
            </h3>
            <p className="text-muted-foreground">
              Domine a linguagem do mercado imobiliário. Termos técnicos de construção,
              documentação, direito imobiliário e muito mais ao seu alcance.
            </p>
          </div>
          <Button className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground">
            Acessar Dicionário
          </Button>
        </div>
      </Link>
    </section>
  );
};
